import { SET_CONFIG_CSV_IMPORT_MODAL } from '../actionTypes';
import { actions } from '../reducer';

export default (config) => actions[SET_CONFIG_CSV_IMPORT_MODAL](config);
